import JumboDdMenu from "@jumbo/components/JumboDdMenu";
import VideoSettingsIcon from '@mui/icons-material/VideoSettings';
import { getObjectListByPropertyApi } from "api/general";
import { postMeetingVideoCallRecordApi, postMeetingVideoCallStartApi } from "api/meeting";
import { MEETING_VIDEO } from "app/utils/constants/customConstant";
import { useState } from "react";
import { useSelector } from "react-redux";
import { NotificationManager } from "react-notifications";
import Swal from "sweetalert2";
import LoadingPopUp from "./LoadingPopup";
import VideoLinkDialog from "./Dialog/VideoLinkDialog";
import VideoWatchDialog from "./Dialog/VideoWatchDialog";

function VideoMenuGroup({ meeting, isEditable, afterUpdateFunc }) {

    const authUser = useSelector((state) => state.auth.authUser);
    const [videoLinkDialogStatus, setVideoLinkDialogStatus] = useState(false);
    const [videoWatchStatus, setVideoWatchDialogStatus] = useState(false);
    const [busy, setBusy] = useState(false);

    const withBusy = async (fn) => {
        setBusy(true);
        try {
            await fn();
        } catch (error) {
            NotificationManager.error(
                error?.response?.data?.errorMessage || error?.message || 'Bağlantı hatası oluştu.',
                '',
                4000
            );
        } finally {
            setBusy(false);
        }
    };


    const menu = [
        ...(meeting.meetingUrl === null || meeting.meetingUrl === "" ? [
            { title: "Toplantı Bağlantısını Oluştur", type: '1' },
        ] : []),
        { title: "Toplantı Bağlantısını Ekle/Sil", type: '3' },
        { title: "Toplantı Video İzle", type: '4' }
    ];

    const filteredMenu = !isEditable
        ? menu.filter(item => item.type === '4')
        : menu;

    const videoButtonsClick = async (option) => {

        if (option.type === '1') {

            let meetingObj = { ...meeting };

            const result = await Swal.fire({
                title: "Toplantı Bağlantısını Oluşturmak",
                text: "Toplantı bağlantısını oluşturmak istediğinizden emin misiniz?",
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Evet',
                cancelButtonText: "Vazgeç"
            });

            if (!result.isConfirmed) {
                return;
            }

            await withBusy(async () => {
                meetingObj.adminUserId = authUser.id;
                let { user, users, ...updatedMeetingObj } = meetingObj;

                const res = await postMeetingVideoCallStartApi(updatedMeetingObj);

                if (res.status) {
                    meetingObj = {
                        ...updatedMeetingObj,
                        meetingUrl: res.data.joinUrl,
                        meetingShortUrl: res.data.meetingShortUrl,
                        teamsId: res.data.teamsId,
                        createVideoStatus: 1,
                        user: authUser,
                        users
                    };

                    afterUpdateFunc && afterUpdateFunc({ ...meetingObj });
                    NotificationManager.success('İşlem başarılı.', '', 2000);
                } else {
                    NotificationManager.error(res.errorMessage || 'Bağlantı oluşturulamadı.', '', 3000);
                }
            });

        } else if (option.type === '2') {

            await withBusy(async () => {
                let result = await getObjectListByPropertyApi(MEETING_VIDEO, "meetingId", meeting.id);
                let data = result.data;
                data = data.filter(item => item.status === 1 && item.type === 1);
                if (data.length > 0) {
                    NotificationManager.error("Bu toplantının video kaydı zaten mevcuttur.", '', 5000);
                    return;
                }

                const res = await postMeetingVideoCallRecordApi(meeting);
                if (res.status) {
                    NotificationManager.success(res.data.message || 'İşlem başarılı.', '', 5000);
                } else {
                    NotificationManager.error(res.data?.message || 'İşlem başarısız.', '', 5000);
                }
            });

        } else if (option.type === '3') {
            setVideoLinkDialogStatus(true);
        } else if (option.type === '4') {
            setVideoWatchDialogStatus(true);
        }

    }
    return (

        <>
            <LoadingPopUp open={busy} blocking message="" />
            <JumboDdMenu
                ariaLabel="Video Konferans Ayarları"
                icon={<VideoSettingsIcon />}
                menuItems={filteredMenu}
                onClickCallback={(option) => videoButtonsClick(option)}
            />


            <VideoLinkDialog
                open={videoLinkDialogStatus}
                onClose={() => setVideoLinkDialogStatus(false)}
                meeting={meeting}
                setVideoLinkDialogStatus={setVideoLinkDialogStatus}
                afterUpdateFunc={afterUpdateFunc}
            />

            {
                videoWatchStatus && videoWatchStatus === true ?
                    <VideoWatchDialog
                        open={videoWatchStatus}
                        onClose={() => setVideoWatchDialogStatus(false)}
                        meeting={meeting}
                        setVideoWatchDialogStatus={setVideoWatchDialogStatus}

                    /> : ""
            }

        </>

    );
}

export default VideoMenuGroup
